import { HeadingText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1e9dag5";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const borderCss = "b1d6uhtc";
const Border = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'hr';
  return <Component ref={ref} {...restProps} className={classNames(borderCss, props.className)} />;
});
const contentIsPhoneCss = "c1hyvoi0";
const contentCss = "c1nc3jxy";
const Content = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(contentCss, {
    [contentIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const Divider = ({
  children
}) => {
  const isPhone = useDeviceType('isPhone');
  return <Container>
      {!isPhone && <Border />}
      <Content>
        <HeadingText variant="eyebrow" size="large">
          {children}
        </HeadingText>
      </Content>
      {!isPhone && <Border />}
    </Container>;
};

require("./divider.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./divider.js");